// src/views/HomePagee/index.js
import React from "react";
import { useHistory } from "react-router-dom";
import "./homepage.css";

const HomePage = () => {
  const history = useHistory();

  const apps = [
    {
      name: "NissiSpace",
      route: "/download",
      icon: "/images/nissiIcon.png",
      subtitle: "Your gateway to seamless collaboration",
    },
    {
      name: "SeekSpace",
      route: "/downloadseekspace",
      icon: "/images/seekspace/icon.png",
      subtitle: "Explore the universe of knowledge",
    },
    {
      name: "VisionSpace",
      route: "/downloadvision",
      icon: "/images/mookervision/favicon.jpg",
      subtitle: "Your gateway to visual exploration",
    },
    {
      name: "GoReading",
      route: "/downloadgoreading",
      icon: "/images/goreading/favicon.png",
      subtitle: "Your gateway to digital reading",
    },
    // {
    //   name: "Pingfan",
    //   route: "/downloadpingfan",
    //   icon: "/images/pingfan/favicon.jpg",
    //   subtitle: "Your gateway to seamless communication",
    // },
    {
      name: "KeepSpace",
      route: "/downloadkeepspace",
      icon: "/images/keepspace/icon.png",
      subtitle:
        "Reimagine learning with powerful digital tools. Built for progress. Made for you.",
    },
  ];

  return (
    <div className="home-container">
      <header>
        <h1 className="title">🚀 Welcome to the NissiSpace 🚀</h1>
        <p className="sub-text">Select an app to download</p>
        <p className="sub-text">
          It will automatically detect your operating system/platform and start
          downloading the app.
        </p>
      </header>

      <div className="card-grid">
        {apps.map((app) => (
          <div
            key={app.name}
            className="app-card"
            onClick={() => history.push(app.route)}
          >
            <img src={app.icon} alt={app.name} className="app-icon" />
            <div className="app-name">{app.name}</div>
            <div className="app-name-subtitle">{app.subtitle}</div>
          </div>
        ))}
      </div>

      <footer className="footer">
        <div>NissiSpace</div>
        <div>© NISSISPACE PTE. LTD. 2022</div>
      </footer>
    </div>
  );
};

export default HomePage;
